import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TabelaPrecoService } from '@app/modules/tabelapreco/services';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';



@Component({
  selector: 'app-fast-tabela',
  templateUrl: './fast-tabela.component.html',
  styleUrls: ['./fast-tabela.component.scss'],
  providers: [TabelaPrecoService]
})
export class FastTabelaComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  loadingCodigo = true;

  public messages = {
    codigo: {
      required: 'O código é obrigatório.',
      pattern: 'O código deve conter 3 números.',
      repeated: 'Código já em uso.'
    },
    nome: {
      required: 'O nome da tabela é obrigatório.',
      maxlength: 'O nome deve conter no máximo 60 caracteres.',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    perc_desc_acresc: {
      required: 'O desconto/acréscimo é obrigatório.',
      pattern: 'Este valor é invalido.',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    }
  };

  constructor(
    private fb: UntypedFormBuilder,
    private tokenService: TokenService,
    public entityService: TabelaPrecoService,
    private dialogRef: MatDialogRef<FastTabelaComponent>,
    protected matSnackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [null, [Validators.required, Validators.maxLength(60), CustomValidators.isEmptyValue()]],
      perc_desc_acresc: [
        0,
        [
          Validators.required,
          CustomValidators.validateCurrencyValues(5,2),
          CustomValidators.existSpecialChar(true),
          // Validators.pattern(/^(-)?((100)|(\d{1,3}(.\d*)?))$/)
        ]
      ],
      atualizar_auto: [null !== false]
    });
  }

  validateNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }


  onSubmit() {
    this.loading = true;
    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    entity = Utils.trimAttributes(entity);
    entity.perc_desc_acresc = Utils.replaceCommaToDot(entity.perc_desc_acresc);
    this.entityService.insert(entity).subscribe(
      tabela_preco => {
        this.matSnackBar.open('Tabela de preço cadastrada.','X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-success']
        });
        this.dialogRef.close(tabela_preco);
        this.loading = false;
      },
      () => {
        this.loading = false;

        this.matSnackBar.open('Erro ao cadastrar tabela de preço.','X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-error']
        });
      }
    );
  }
}
